import { Sizes } from 'styled-components';
import { styled } from '../../../core/theme/styled';

type Spacing = Exclude<Sizes, 'auto' | 'none'>;

export type StackProps = {
  justifyContent?:
    | 'center'
    | 'normal'
    | 'space-between'
    | 'space-around'
    | 'flex-end'
    | 'flex-start';
  alignItems?: 'center' | 'start';
  gap?: Spacing;
  verticalPadding?: Spacing;
};

export const Stack = styled.div.attrs({ 'data-testid': 'Stack' })<StackProps>`
  display: flex;
  flex-direction: column;
  flex: 1;
  ${({ justifyContent }) =>
    justifyContent &&
    `
    justify-content: ${justifyContent};
  `}
  ${({ alignItems }) =>
    alignItems &&
    `
    align-items: ${alignItems};
  `}
    ${({ gap, theme }) =>
    gap &&
    `
    gap: ${theme.sizes[gap]};
  `};
  ${({ verticalPadding, theme }) =>
    verticalPadding &&
    `
    padding-top: ${theme.sizes[verticalPadding]};
    padding-bottom: ${theme.sizes[verticalPadding]};
  `};
`;
